import cx from 'classnames';
import { useNCTextLocalizer } from '../../../locale/useNCTextLocalizer';
import { renderInlineCssVars, useDesignTokens } from '../../../theme';
import { postfixTestId } from '../../../util/testId';
import { Label } from '../../Label';
import { Flow } from '../../Layouts/Flow';
import { useCustomColorPickerA11yInfo } from './hooks/useCustomColorPickerA11yInfo';
import cn from './ColorIndicator.css.json';
import './ColorIndicator.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ColorIndicator = props => {
  const localize = useNCTextLocalizer('ColorPicker');
  const {
    currentColor,
    newColor
  } = props;
  const getCustomColorPickerA11yInfo = useCustomColorPickerA11yInfo();
  const {
    currentAriaLabel,
    currentToolTip,
    newAriaLabel,
    newToolTip
  } = getCustomColorPickerA11yInfo(currentColor.color, currentColor.type, newColor.color, newColor.type);
  const dt = useDesignTokens();
  const colorIndicatorTokens = renderInlineCssVars({
    'spacing-xs': dt.tokens['space-base-xs'],
    'no-color-mark': dt.tokens['color-status-alert'],
    'swatch-bd': dt.tokens['color-container-border-4'],
    'automatic-swatch-width': '1.5rem'
  }, 'color-indicator');
  const MultiColorSwatchComponent = props.renderAutomaticSwatch ? props.renderAutomaticSwatch({
    getAttributes() {
      return {
        // eslint-disable-next-line @sas/i18n/jsx-to-localize
        ariaLabel: `${localize('currentColorAutomatic.label')} ${localize('automatic.label')} (${localize('multipleSmallCaseColors.label')})`,
        // eslint-disable-next-line @sas/i18n/jsx-to-localize
        title: `${localize('currentColorAutomatic.label')} ${localize('automatic.label')} (${localize('multipleSmallCaseColors.label')})`,
        className: cn.currentMultiColor,
        tabIndex: 0,
        role: 'img'
      };
    }
  }) : null;
  return /*#__PURE__*/_jsxs(Flow, {
    "data-testid": postfixTestId(props.testId, 'currentNewSwatchContainer'),
    className: cn.currentNewSwatchContainer,
    spacing: "none",
    style: colorIndicatorTokens,
    children: [/*#__PURE__*/_jsx(Label, {
      testId: postfixTestId(props.testId, 'currentLabel'),
      children: localize('customTab.currentColorSwatch.label')
    }), /*#__PURE__*/_jsxs(Flow, {
      spacing: "none",
      className: cn.currentNewSwatchWrapper,
      children: [currentColor.type === 'automatic' && props.renderAutomaticSwatch ? MultiColorSwatchComponent : /*#__PURE__*/_jsx(Flow, {
        role: "img",
        spacing: "none",
        tabIndex: 0,
        className: cx(cn.swatch, currentColor.color === '' && cn.noColor),
        "data-testid": postfixTestId(props.testId, 'currentColorSwatch'),
        title: currentToolTip,
        "aria-label": currentAriaLabel,
        style: {
          backgroundColor: currentColor.color
        }
      }), /*#__PURE__*/_jsx(Flow, {
        role: "img",
        spacing: "none",
        tabIndex: 0,
        className: cx(cn.swatch, newColor.color === '' && cn.noColor),
        "data-testid": postfixTestId(props.testId, 'newColorSwatch'),
        title: newToolTip,
        "aria-label": newAriaLabel,
        style: {
          backgroundColor: newColor.color
        }
      })]
    }), /*#__PURE__*/_jsx(Label, {
      testId: postfixTestId(props.testId, 'newLabel'),
      children: localize('customTab.newColorSwatch.label')
    })]
  });
};
//# sourceMappingURL=ColorIndicator.js.map